import reduceReducers from 'reduce-reducers';

//Siblings reducers
import companyAssetReducer from './company-asset';

export default reduceReducers(companyAssetReducer);
